import React, { Component } from 'react';
import "./info.css"
import   SideNav from "./../../component/sidenav/sidenav.js"
import ReactCrop, { makeAspectCrop } from 'react-image-crop'
import  AuthService  from "../api/authentication.js";
import { DatetimePicker, DatetimePickerTrigger, DatetimeRangePicker  } from 'rc-datetime-picker';
import 'react-image-crop/dist/ReactCrop.css'
import {base64StringtoFile,
downloadBase64File,
extractImageFileExtensionFromBase64,
image64toCanvasRef} from './ResuableUtils'
import moment from 'moment';
import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect
  } from 'react-router-dom'

import axios from 'axios';
var dataE = [
    "1 -- 10",
    "1 -- 50",
    "1 -- 100",
    "1 -- 200",
    "1 -- 300",
    "1 -- 400",
    "1 -- 500",
]

var dataC = [
  "Nigeria",
 
]
// https://uvune-events.herokuapp.com
const Auth = new AuthService();
class Info extends Component {
    constructor(props) {
        super(props)
     
      this.state ={
         inputOpenFileRef : React.createRef(), 
         image : "",
         loading: false,
         file: '',
         moment: moment(),
            inFocus: '',
            firstTime :false,
            noerorrpage :  true,
            IfOrganizersNext : false,
            bankName : [],
            account_bank : "",
            loadingbank : false,
            selectbank:"false",
            errorinfo : "",
            errorIf : false,
            IfBank:false,
            domain: 'https://uvune-listing.herokuapp.com', 
            checkorganizers:false,
            select : "",
            Employees : [],
            type:[],
            verified :""

       
      }
   
        
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
       
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            // body: JSON.stringify(dataedit),
          };
        this.setState ({
            Employees: dataE,
            type : dataC,
            select :dataE[0],
            selectC : dataC[0],

        })

        //   console.log("data", requestOptions)
          fetch(this.state.domain+"/users/"+ Auth.getProfile().userId, requestOptions )
          .then(res => res.json())
          .then((res)=>{
            if(res){
                // console.log("org ---========>", result.organizers_id)
                fetch(this.state.domain+"/companies/"+ res.company_id , requestOptions)
                .then(ressult => ressult.json())
                .then((result)=>{
                    if(result){
                      // console.log("result  ----------->>result.organizers_id",  result)
                        if(result.code === 400 || result.code === 404 || result.name ===  "NotFound" ){
                          this.setState({
                       
                            checkorganizers:false
                          })
                        
                        }else{
                            this.setState({
                       
                                checkorganizers:true
                              })
                             
                        }
                   
                    }
                  
                }).catch( (error) => {
                    //  console.log("errro", error);
                    //  console.log("error load", error )
                 });

                // console.log("more setting users", result)
                 
    
            }
          }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });
        
        const requestOptions1 = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json', "Authorization": "Bearer pk_live_2f7476238ad68273a257ad7f3ee236c4efdcade7"},
            // body: JSON.stringify(dataedit),
          };

    //  fetch("https://api.paystack.co/bank", requestOptions1)
    //   .then(res => res.json())
    //   .then((result)=>{
    //       if(result){
    //         //   console.log("bank ----=====> in nigeria",result.data)
    //           this.setState({
    //               bankName :result.data,
    //                loadingbank : true,
    //                IfBank : true
    //           })
    //       }else{
             
    //       }
    //   })
  
    }
    
    onImageLoaded = (image) => {
        this.setState({
          crop: makeAspectCrop({
            x: 0,
            y: 0,
            aspect: 16 / 9,
            width: 50,
          }, image.width / image.height),
        });
      }

    

    upDate_data = (event) =>{
        event.preventDefault()
        // console.log("data update===----->", this.chechconditionIinput())
        if(this.state. submitIftrue){
        this.setState({
            loading:true
        })
         const data = {
            official_name : this.name.value,
            short_name : this.name.value,
            business_email :this.email.value,
            business_mobile:this.business_mobile.value,
            established :this.established.value,
            location_country: this.state1.selectC,
            location_state : this.state1.value,
            location_city: this.city.value,
            main :this.main.value,
            total_employees : this.state.select,
            verified : this.state.verified,
            business_type : this.state.selectC,
            address : this.address.value,
            description :this.description.value
          
         }

         const requestOptions = {
             method: 'post', 
             headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
             body: JSON.stringify(data)
            //  body: JSON.stringify(login)
         };
        console.log("data update", data, requestOptions, this.props.user. _id)
         fetch(this.state.domain+"/companies", requestOptions)
         .then(res => res.json())
         .then((res)=>{
             if(res){
              // console.log("data update===----->", res)
                 if(res.code === 500 || res.code === 400 === res.code === 409){
                    this.setState({
                        loading:false,
                        errorinfo : "Wrong Account details try again",
                        errorIf:true
                    })
                    this.timeout()
                   
                 }else{
                    // console.log("result", result._id, result)
                    this.setState({
                        loading:false
                    })
                    const update_data1 = {
                      company_id : res._id,
                   }
                    const requestOptionsUser = {
                       method: 'PATCH', 
                       headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
                       body: JSON.stringify(update_data1),
                   };
                   this.props.setGlobalorganizers(res)
                //    console.log("data update", requestOptions, this.props.user. _id)
                   fetch(this.state.domain+"/users/"+ this.props.user._id, requestOptionsUser)
                   .then(result => result.json())
                   .then((result)=>{
                       if(result){
                        //    console.log("result", result1)
                           this.setState({
                               loading:false
                           })
                           
                           this.props.history.replace('/dashboard');
                       }
                     
                   }).catch( (error) => {
                       //  console.log("errro", error);
                        // console.log("error load", error )
                    });
                 }
                
             }
           
         }).catch( (error) => {
             //  console.log("errro", error);
                this.setState({
                    submitIftrue:true
                })
            //   console.log("error load", error )
      });
       }else{
        //   console.log("false")
       }    
       

    }


    timeout() {
        setTimeout(function() {
       //    this.setState({ imageshow:false})
         this.setState({
            errorIf:false
         })
        //   console.log("time out",this.state.showimage);
        }.bind(this), 4000);
      }


    handlechangecategory=(event)=>{
        //  console.log("event.target.value-----===>",event.target.value)
        this.setState({
            account_bank :event.target.value,
            selectbank:"true"
        })
    }

    isEmpty=(val)=>{
        return (val === undefined || val === null || val.length <= 0) ? true : false;
    }
    

    selectChange = (e)=>{
        this.setState({
            select: e.target.value
          })
        //  console.log("data--===------> contry", e.target.value)
     }

     selectChangeC = (e)=>{
      this.setState({
          selectC: e.target.value
        })
      //  console.log("data--===------> contry", e.target.value)
   }


     selectVerified = (e)=>{
        this.setState({
            verified: e.target.value
          })
        //  console.log("data--===------> contry", e.target.value)
     }

   


    handleClearToDefault = event =>{
        if (event) event.preventDefault()
        // console.log("   clearimage",   )
        
        this.setState({
            clearimage : false
        })
        
        // console.log("   clearimage",  this.state. clearimage)
    }

    changeAbout=(e)=> {
        this.setState({ about: e.target.value });
        // console.log(this.chechconditionIinput())
        if( !this.state.fullname == "" && !this.state.location == ""  &&  !this.state.about == "" || e.target.value !== ""){
          this.setState({
                submitIftrue : true
              })
            //  console.log("state submit", this.state.submitIftrue)
            return true
        }else{
            this.setState({
                submitIftrue : false
              })
            //  console.log("state submit", this.state.submitIftrue)
            return  false
        }

    }


        locationChange=(e)=>{
            this.setState({ location: e.target.value });
            // console.log("judge",)
        //   console.log(   this.Is_Empty_or_Undefined ( e.target.value))
        this.chechconditionIinput()
            // console.log(this.chechconditionIinput())
        }

        handlefullnameChange  = (e) => {
            e.preventDefault()
            this.setState({ fullname: e.target.value });
            // console.log("fullname", e.target.value )
            this.chechconditionIinput()
            // console.log(this.chechconditionIinput())
         }

         

      
      
         chechconditionIinput=()=>{
            //  console.log("judge chechconditionIinput")
              if(!this.state.fullname == "" && !this.state.location == ""  &&  !this.state.about == ""){
                 this.setState({
                    submitIftrue : true
                 })
                //  console.log("state submit", this.state.submitIftrue)
                return true
            }else{
                this.setState({
                    submitIftrue : false
                 })
                //  console.log("state submit", this.state.submitIftrue)
                return  false
            }
         }

         


         handleChange = (moment) => {
            this.setState({
              moment
            });
            // console.log("data--===>time", this.state.moment._d)
          }
        
        
        logout = () =>{
            // console.log("judge love")
            this.props.logout()
          }
        
          clickeme=()=>{
            // console.log("click me")
        }
          
        
  render() {
    const shortcuts = {
        'Today': moment(),
        'Yesterday': moment().subtract(1, 'days'),
        'Clear': ''
      };

    // console.log("disable  ----->  Employees", this.state.Employees)
   if (this.state.checkorganizers){
       return(
      
          <Redirect to={{    pathname: `${'/dashboard'}`  }}/>
            )
    }else{

    return (
               
        <div id="dashboard-wrapper " class="columns dashboard-cousom">
            <div class="column"></div>
            <div class="content column is-11">
        
                {/* <!-- Breadcrumbs --> */}
                <nav class="breadcrumbs">
                    <ul>
              
                        {/* <li><a href="/">Home</a></li>
                        <li>Create comapany profile</li> */}
                    </ul>
                </nav>
                {/* <!-- /Breadcrumbs -->
        
                <!-- Dashboard Wrapper --> */}
            <div class="dashboard-wrapper">
            <div className="newcomapany-fullbody">
        
                     {
                       this.state.hidetemple ?
                       <div></div>
                       :
                       <div>
                          {/* <div className="newcomapany-body-info">
                              Selete tamplet
                            </div>
                          <div className="newcomapany-body-tamplet-body">
                            <ul className="newcomapany-body-tamplet-list">
                                <a onClick={this.selectTemplet}>
                                  <li >
                                    <div className="newcomapany-body-tamplet-img">
                                        <img src="https://res.cloudinary.com/easywaya/image/upload/v1562485796/Screenshot_ckzohw.png" alt=""/>
                                      
                                    </div>
                                    <div className="newcomapany-body-tamplet-para">
                                      
                                         blue business
                                    </div>
                                   
                                  </li>
                                </a>
                            </ul>
                          </div> */}
                      </div>
                     }
                    
                     <div className="info-body-full">
                       <div className="info-body-head">
                          <p>Create company </p> 
                           <hr/>
                       </div>
                       
                   
    <form onSubmit={this.upDate_data}>
                     <div class="columns">
                      <div class="column is-one-third">Company Name:</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                               ref={ input => this.name = input }
                               onChange={this.handlefullnameChange }
                               onChange={this.handlefullnameChange }
                              placeholder="Company Name" required/>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                          <div class="column is-one-third"> Company Email  </div>
                          <div class="column">
                              <div class="control">
                                  <input class="input is-small" type="text" 
                                    ref={ input => this.email = input }
                                 
                                  placeholder="Company email" required/>
                                </div>
                              </div>
                          </div>

                           
                                      
                          <div class="columns">
                            <div class="column is-one-third">  Company  Phone </div>
                            <div class="column">
                                <div class="control">
                                    <input class="input is-small" type="text" 
                                      ref={ input => this.business_mobile = input }
                                    
                                    placeholder="Company phone" required/>
                                  </div>
                                </div>
                            </div>

                      <div class="columns">
                      <div class="column is-one-third">Country </div>
                         <div class="column">
                         <div class="control has-icons-left">
                                  <div class="select is-small">
                                    <select style={{width:"380px"}} onChange={this.selectChangeC}  class="form-control" value={this.state.selectC}>
                                    <option value={this.state.selectC}>{this.state.selectC}</option>
                                        {/* {
                                            this.state.type.map(data  => {
                                                return  <option  key={data} value={data}>{data}</option>
                                            })
                                        } */}
                                    </select>
                                  </div>
                                  <span class="icon is-small is-left" >
                                    <i class="fas fa-globe" style={{position:"relative",bottom:"5px"}}></i>
                                  </span>
                             </div>
                         
                          </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">State</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                              ref={ input => this.state1 = input }
                              placeholder="State" required/>
                            </div>
                          </div>
                      </div>

                      <div class="columns">
                      <div class="column is-one-third">City</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                              ref={ input => this.city = input }
                              placeholder="City" required/>
                            </div>
                          </div>
                      </div>


                      <div class="columns">
                      <div class="column is-one-third">Company  Address</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                                 ref={ input => this.address = input }
                                 onChange={this.locationChange }
                              placeholder="Company Operational Address" required/>
                            </div>
                          </div>
                      </div>


                      {/* <div class="columns">
                      <div class="column is-one-third">Business type:</div>
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <div class="select is-small">
                               <select onChange={this.selectChangeC}  class="form-control" value={this.state.selectC}>
                                            <option value={this.state.selectC}>{this.state.selectC}</option>
                                        {
                                            this.state.type.map(data  => {
                                                return  <option  key={data} value={data}>{data}</option>
                                            })
                                        }
                                        
                                                    
                              </select>
                            </div>
                          </div>
                        </div>
                        </div>
                      </div> */}

                      

                      {/* <div class="columns">
                      <div class="column is-one-third">Business type </div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                                 ref={ input => this.type = input }
                              placeholder="Business type"/>
                            </div>
                          </div>
                      </div> */}

                      <div class="columns">
                      <div class="column is-one-third">Main products </div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                                 ref={ input => this.main = input }
                              placeholder="Main products" required/>
                            </div>
                          </div>
                      </div>


                      
                      <div class="columns">
                      <div class="column is-one-third">  Established </div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" 
                                 ref={ input => this.established = input }
                              placeholder="Year  Established" required/>
                            </div>
                          </div>
                      </div>


                      {/* <div class="columns">
                      <div class="column is-one-third">Company Registered</div>
                      <div class="column">
                          <div class="control">
                               <DatetimePickerTrigger
                                            shortcuts={shortcuts} 
                                            moment={this.state.moment}
                                            onChange={this.handleChange}>
                                            <input type="text" className="input" value={this.state.moment.format('YYYY')} readOnly  required/>
                                </DatetimePickerTrigger>
                            </div>
                          </div>
                      </div> */}

                      <div class="columns">
                      <div class="column is-one-third">Is The Company Verified:</div>
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <div class="select is-small">
                               <select onChange={this.selectVerified} style={{width:"380px"}}  class="form-control" value={this.state.verified}>
                                            <option value="true">YES</option>
                                            <option value="false">NO</option>           
                              </select>
                              {/* <select>
                                <option value="">--- Please select ---</option>
                                <option>With options</option>
                              </select> */}
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                     

                      <div class="columns">
                      <div class="column is-one-third">Total No. Employees:</div>
                      <div class="column">
                        <div class="field">
                          <div class="control">
                            <div class="select is-small">
                               <select onChange={this.selectChange} style={{width:"380px"}}  class="form-control" value={this.state.select}>
                                            <option value={this.state.select}>{this.state.select}</option>
                                        {
                                            this.state.Employees.map(data  => {
                                                return  <option  key={data} value={data}>{data}</option>
                                            })
                                        }
                                        
                                                    
                              </select>
                              {/* <select>
                                <option value="">--- Please select ---</option>
                                <option>With options</option>
                              </select> */}
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                      {/* <div class="columns">
                      <div class="column is-one-third">Company Website Url if any</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Company Website Url if any"/>
                            </div>
                          </div>
                      </div> */}


                      {/* <div class="columns">
                      <div class="column is-one-third">Legal Owner:</div>
                      <div class="column">
                          <div class="control">
                              <input class="input is-small" type="text" placeholder="Legal Owner"/>
                            </div>
                          </div>
                      </div> */}


                      
                      {/* <div class="columns">
                          <div class="column is-one-third">Office Size:</div>
                          <div class="column">
                              <div class="field">
                              <div class="control">
                                <div class="select is-small">
                                  <select>
                                    <option value="">--- Please select ---</option>
                                    <option>With options</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div> */}


                      <div class="columns">
                      <div class="column is-one-third">About Us:</div>
                      <div class="column">
                          <div class="control">
                          <textarea class="textarea" ref={input => this.description = input} 
                          onChange={this.changeAbout} placeholder="Company Desription" required></textarea>
                            </div>
                          </div>
                      </div>

                      {/* <button onClick={this.clickeme}>click</button> */}
                      {
                                this.state.loading ? 
                                <div className="hero is-bold is-fullheight">
                                       <div className="level-item">
                                       <a className="button is-loading is-large is-light">Loading</a>
                                       </div>
                                       
                                   </div>
                                 :
                                 <div >
                                     {
                                      this.state.submitIftrue ? 
                                        <div className="info-payment-button">
                                          <button  class="button is-primary is-rounded"  style={{width:"85%"}}>Submit</button>
                                        </div>
                                        :
                                        <div className="info-payment-button">
                                         
                                          <a className="button is-success" title="Disabled button" style={{width:"85%"}} disabled>Submit</a>
                                        </div>
                                     }
                                 </div>
                             
                                }

                       
                       </form>    
                     </div>
                    
                </div>
            </div>
          </div>  
       </div>     

)


   }
    
}





}

export default Info;
const SelectList = (props) => {
//   console.log("posps ===---->", props)
    const optionsItem  =  props.categories.map( (category) => 

        <OptionItem   key={category.code}  id={category.slug} name={category.name}  />
    )

        return (
                <select onChange={props.handlechangecategory}  className="form-control color-black-lightest font-size-10">
                <option   selected value="None" >Select bank </option>

                   { optionsItem }                                                         
                                                                            
                </select>
                        
                
        )
}





const OptionItem = (props) => {
    //console.log("available props", props);

    return (
            <option  value={props.name} > {props.name} </option>

    )
}



// WEBPACK FOOTER //
// ./src/component/info/info.js